import {
  BooleanInput,
  Create,
  CreateContextProvider,
  Form,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  Toolbar,
  TopToolbar,
  useCreateController,
  useNotify,
  useRedirect,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Box,
  Card,
  Divider,
  Stack,
  Typography,
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../resource';
import AgentsForm from './AgentsForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateAgents = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.agents,
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.agents.createSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        switch (errorCode) {
          default:
            notify(t('module.agents.unknownError'), { type: 'error' });
            break;
        }
      },
    },
  });

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.agents.createAgents')}</DialogTitle>
        <DialogContent>
          <AgentsForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="agents" action="create">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateAgents;
